import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import purpleLogo from "../assets/purpleKnowtexLogo.svg";

function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>Not Found – Knowtex</title>
      </Helmet>
      <main
        id="main-content"
        tabIndex="-1"
        className="relative flex min-h-screen w-[100dvw] items-center justify-center overflow-x-hidden bg-background1 px-4 py-12"
      >
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-left bg-auto bg-login-background -scale-x-100"
        />

        <section className="relative z-10 w-full max-w-lg rounded-xl bg-white px-8 py-10 text-center shadow-drop-shadow tablet:px-12">
          <img src={purpleLogo} alt="Knowtex" className="mx-auto h-auto w-64 max-w-full" />
          <p aria-hidden="true" className="mt-8 text-7xl font-bold leading-none text-accent2">
            404
          </p>
          <h1 className="mt-5 text-3xl font-bold text-accent1">Page not found</h1>
          <p className="mt-4 text-base leading-7 text-knowtex-grey">
            The page you are looking for does not exist, may have moved, or is no longer available.
          </p>
          <Link
            to="/"
            className="kx-focus mt-8 inline-flex min-h-11 items-center justify-center rounded-lg bg-accent2 px-8 py-3 font-semibold text-white transition-colors hover:bg-dark-purple"
          >
            Return to Knowtex
          </Link>
        </section>
      </main>
    </>
  );
}

export default PageNotFound;
